import Color from '@bubble-dev/fantasy-color';
import { createVersionedColor } from './helpers';

// --- special utility color functions ---

// overlay color for dialogues
/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var overlayDesktop = createVersionedColor(Color.of(0x34, 0x34, 0x34, 0.5));

/**
 * @deprecated this constant is outdated and will be removed with v6.0.0
 */
export var transparent = createVersionedColor(Color.of(255, 255, 255, 0));
//# sourceMappingURL=asFunctions.js.map